import Marquee from "react-fast-marquee";

const WORDS = [
  "NOLENA GLOBAL",
  "SEVGİYLE ÜRETİYORUZ",
  "KALİTELİ ÜRETİM",
  "GÜVENİLİR İŞ ORTAKLIĞI",
];

export const EditorialMarquee = ({ content = {} }) => (
  <section
    id="kayan-serit" data-testid="editorial-marquee"
    className="bg-brand py-1 sm:py-2 overflow-hidden"
    aria-hidden="true"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {(content.marquee_words?.length ? content.marquee_words : WORDS).map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-heading font-semibold text-cream/95 text-xl sm:text-3xl tracking-tight px-8">
            {w}
          </span>
          <span className="text-cream/40 text-xl sm:text-3xl">•</span>
        </span>
      ))}
    </Marquee>
  </section>
);
